import { Injectable } from '@angular/core';
import { BaseService } from '@eview/core/base/base-service';
import { ChartsPayload, RegionDataPayload } from '@eview/core/models/dashboard';
import { Observable, of } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class DashboardService extends BaseService {
    readonly uris = {
        getRegionData: 'posts/dashboardregion',
        getChartsData: 'posts/dashboardtrend',
        getStats: 'posts/stats'
    };

    getRegionData(payload: RegionDataPayload): Observable<any> {
        return this.http.get<any>(this.getUrl(this.uris.getRegionData), {
            params: super.getParamsFromObject(payload)
        });
    }

    getChartsData(payload: ChartsPayload): Observable<any> {
        return this.http.get<any>(this.getUrl(this.uris.getChartsData), {
            params: super.getParamsFromObject(payload)
        });
    }

    getStats(payload: Record<string, any>): Observable<any> {
        return this.http.get<any>(this.getUrl(this.uris.getStats), {
            params: super.getParamsFromObject(payload)
        });
    }
}
